import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "../CommercialComponents/commercialimagesshow/MagellanShow";
import DawlanceSelection from "../Selection2/DawlanceSelection";
import AzelSelection from "../Selection2/AzelSelection";
import ExternalSlider from "./ExternalSlider";
import CoastalSelection from "../Selection2/CoastalSelection";
import LocaSelection from "../Selection2/LocaSelection";
import PrivateVillaSelection from "../Selection2/PrivateVillaSelection";
import VillaShow from "./ExteriorImageShow/VillaShow";
import PrivateVillaShow from "./ExteriorImageShow/PrivateVillaShow";
import ReactPlayer from "react-player";

export default function PrivateVillaComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/exteriorimages/6-PrivateVillaLandscape/43.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5"> Private Villa Landscape</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization,
                  execution
                </span>
                <span>project duration: 4 months</span>
                <span>year of completion: 2024</span>
                <span>project location: Al Rayyan, Doha-QATAR</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
               src="../../Images/exteriorimages/6-PrivateVillaLandscape/44.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                src="../../Images/exteriorimages/6-PrivateVillaLandscape/32.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                <br />
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                <br />
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                <br />
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              “Transforming 1300 sqm into a luxurious outdoor sanctuary, where
              contemporary design meets functional elegance.”
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                        src="../../Images/exteriorimages/6-PrivateVillaLandscape/32.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "550px",
                zoom: "90%",
              }}
            >
              This luxurious 1300 sqm landscape design combines contemporary
              aesthetics with functional outdoor living. The project integrates
              key elements, including a pool, an outdoor kitchen, a glasshouse,
              and a cozy firepit area, to create a versatile and inviting
              environment for relaxation and entertainment. Currently in the
              installation phase, the design aims to shape outdoor living.
              <br />
              <br />
              A combination of carefully selected plants and pathways enhances
              the landscape’s flow, creating distinct zones for different
              activities while maintaining a cohesive look.
              <br />
              <br />
              Our role in this project involved conceptualizing and designing
              each element to reflect the client’s lifestyle, ensuring a perfect
              blend of luxury, comfort, and practicality.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                        src="../../Images/exteriorimages/6-PrivateVillaLandscape/32.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <PrivateVillaSelection />
        </section>


           <section className="video-player">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ReactPlayer
                      url="../../Images/exteriorimages/6-PrivateVillaLandscape/privatevillavid1.mp4" // Replace with your video URL
                      controls
                      width="80%"
                      height="100vh"
                    />
                  </div>
                </section>
        

        <section className="banner">
          <div className="img">
            <ParallaxImage
                 src="../../Images/exteriorimages/6-PrivateVillaLandscape/42b.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>



        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                “Transforming 1300 sqm into a luxurious outdoor sanctuary, where
                contemporary design meets functional elegance.”
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        {/* <AzelShow/> */}
      <PrivateVillaShow/>
        <ExternalSlider />
      </div>
    </ReactLenis>
  );
}
